import { RegexOption } from 'src/shared/constants/regex-formats/types/RegexTypes';

export const booleanRegexOptions: RegexOption[] = [
  {
    type: 'boolean',
    display: 'True or False',
    code: 'True / False',
    icon: 'ToggleRight',
    regex: '^true$|^false$',
    examples: ['true', 'True', 'TRUE', 'false', 'False', 'FALSE'],
  },
  {
    type: 'boolean-strict-title',
    display: 'Strict True or False',
    code: 'True / False',
    icon: 'ToggleRight',
    regex: '^(?:True|False)$',
    examples: ['True', 'False'],
  },
  {
    type: 'boolean-strict-lower',
    display: 'Strict true or false',
    code: 'true / false',
    icon: 'ToggleRight',
    regex: '^(?:true|false)$',
    examples: ['true', 'false'],
  },
  {
    type: 'boolean-strict-upper',
    display: 'Strict TRUE or FALSE',
    code: 'TRUE / FALSE',
    icon: 'ToggleRight',
    regex: '^(?:TRUE|FALSE)$',
    examples: ['TRUE', 'FALSE'],
  },
  {
    type: 'boolean-strict-yes no',
    display: 'Strict Yes or No',
    code: 'Yes / No',
    icon: 'ToggleRight',
    regex: '^(?:Yes|No)$',
    examples: ['Yes', 'No'],
  },
  {
    type: 'boolean-strict-success failure',
    display: 'Strict Success or Failure',
    code: 'Success / Failure',
    icon: 'ToggleRight',
    regex: '^(?:Success|Failure)$',
    examples: ['Success', 'Failure'],
  },
];
